
import { Node, mergeAttributes } from '@tiptap/core'

export const LinkPreview = Node.create({
  name: 'linkPreview',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      url: { default: null },
      title: { default: null },
      description: { default: null },
      image: { default: null },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-link-preview]',
        getAttrs: el => {
          const element = el as HTMLElement;
          return {
            url: element.dataset.url,
            title: element.dataset.title,
            description: element.dataset.description,
            image: element.dataset.image,
          };
        }
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      {
        'data-link-preview': 'true',
        'data-url': HTMLAttributes.url,
        'data-title': HTMLAttributes.title,
        'data-description': HTMLAttributes.description,
        'data-image': HTMLAttributes.image,
      },
      '' // empty string = no inner content; actual rendering is handled by NodeView
    ];
  },
  addNodeView() {
    return ({ node, getPos, editor }) => {
      const dom = document.createElement('div');
      dom.className = 'link-preview-inline';
      dom.setAttribute('data-url', node.attrs.url);
      dom.setAttribute('contenteditable', 'false');
      dom.style.marginTop = '12px';

      dom.innerHTML = `
      <div style="
        display: flex;
        border: 1px solid #ccc;
        border-radius: 8px;
        overflow: hidden;
        background: white;
        font-family: sans-serif;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        max-width: 500px;
        position: relative;
      ">
        ${node.attrs.image ? `
          <div style="width: 160px; height: 100px; overflow: hidden; flex-shrink: 0;">
            <img src="${node.attrs.image}" alt="${node.attrs.title}" style="width: 100%; height: 100%; object-fit: cover;">
          </div>` : ''
        }

        <div style="padding: 12px; flex: 1;">
          <div style="font-size: 14px; color: #888;">${new URL(node.attrs.url).hostname}</div>
          <div style="font-weight: bold; font-size: 16px; color: #222; margin: 4px 0;">${node.attrs.title || 'Ingen tittel'}</div>
          <div style="font-size: 14px; color: #444;">${node.attrs.description || ''}</div>
        </div>

        <button type="button" class="remove-link-preview" style="
          position: absolute;
          top: 8px;
          right: 8px;
          background: transparent;
          border: none;
          color: #888;
          font-size: 18px;
          cursor: pointer;
          font-weight: bold;
        ">×</button>
      </div>
    `;

      // Handle remove button
      dom.querySelector('.remove-link-preview')?.addEventListener('click', () => {
        const pos = getPos();
        editor.commands.deleteRange({ from: pos, to: pos + node.nodeSize });
      });

      return { dom };
    };
  }
});
